import React, {useMemo, useRef, useState} from 'react';
import {Tag} from "antd";
import dayjs from "dayjs";
import {MESSAGE_TYPE, messageTypeList} from "../../shared/utils/enum";
import MessageEditModal from "./MessageEditModal";
import TablePage from "../../pages/tablePage/TablePage";

const Message = () => {
    const [rowData, setRowData] = useState({});
    const [topics, setTopics] = useState([]);

    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: 'PushNo.',
            dataIndex: 'id',
            width: 100,
        },
        {
            title: '등록일시',
            dataIndex: 'sendTime',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm'),
            width: 150,
        },
        {
            title: '푸시 타입',
            dataIndex: 'messageType',
            render: (type) => messageTypeList[type].label,
            filters: [
                {
                    text: messageTypeList[MESSAGE_TYPE.IMMEDIATE].label,
                    value: MESSAGE_TYPE.IMMEDIATE,
                },
                {
                    text: messageTypeList[MESSAGE_TYPE.RESERVATION].label,
                    value: MESSAGE_TYPE.RESERVATION,
                },
            ],
            width: 150,
        },

        {
            title: '토픽',
            dataIndex: 'topic',
            render: (topic) => {
                if (topic.length > 3) {
                    topic = topic.slice(0, 2);
                    return topic.map((t) => t.label).join(', ') + ' ...'
                } else {
                    return topic.map((t) => t.label).join(', ')
                }
            },
            width: 350,
        },
        {
            title: '타이틀',
            dataIndex: 'body',
            render: (body) => body[0].title,
            width: 400,
        },
        {
            title: '발송일시',
            dataIndex: 'sendTime',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm'),
            width: 150,
        },
        {
            title: '상태',
            dataIndex: 'state',
            render: (_, {state}) => (
                <Tag color={state ? 'lightgray' : 'green'}>
                    {state ? '발송 완료' : '발송 전'}
                </Tag>
            ),
            width: 100,
        },
        {
            title: '메모',
            dataIndex: 'memo',
        },
    ]), []);

    const props = {
        columns,
        rowData,
        setRowData,
        modal: MessageEditModal,
        refreshRef,
        url: 'message',
        buttonText: '신규 메시지 추가',
        tblData: topics,
        setTblData: setTopics,
    }

    return (
        <TablePage {...props}/>
    );
};

export default Message;